// config
import { ENV } from 'config';

export const PLATFORM_ID = 'UTV';

const CLIENT_ID_MAPPEER: WsMapper = {
  PROD: 'UTV-31qeuxlapso4wnmg07869yzi',
  QA: 'UTV-slh7pterugf603ji2kd14caq',
  UAT: 'UTV-n0wqxov4fc1i5sl29gb6jdhy',
};

export const CLIENT_ID = CLIENT_ID_MAPPEER[ENV];
